module.exports = __webpack_public_path__ + "img/offers1.e54936f0.webp";